import { LegacyContentWrapper } from "@Components/game";
import { BybButtonVR } from "@Components/game/common";
import GameCardGrid from "@Components/game/game-card-grid";
import ContainerWrapper from "@Components/generic/container-wrapper";
import TitleWrapper from "@Containers/shared/title-wrapper";
import { AppContext } from "@Context/common/general/context";
import { faPlayCircle } from "@fortawesome/pro-solid-svg-icons";
import { useApi } from "@hooks/index";
import useI18n from "@i18n";
import { Button, Container, Skeleton, useTheme } from "@mui/material";
import { Api } from "@Shared/schemas";
import { GuideRecord } from "@Shared/schemas/guides/guideSchema";
import React, { useEffect } from "react";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import { AnalyticsEvents } from "@Enums/index";
import Icon from "@Components/generic/icon";
import { DSIcon } from "@Components/common/byb-ds/icons";

const PageId = "GUIDES";

const Guides = () => {
  const { state } = React.useContext(AppContext);
  const { i18n } = useI18n();
  const theme = useTheme();
  const isMobile = state.device.isMobile;
  const { track } = useAnalytics();

  const {
    call: getGuides,
    data: guides,
    loading,
  } = useApi<typeof Api.Guides.GetGuides>({
    api: Api.Guides.GetGuides,
    request: {},
  });

  const showVideo = (videoId?: string | null, title?: string) => {
    if (videoId) {
      state.app.events.showVideo.emit({
        videoId: videoId,
      });
      track(AnalyticsEvents.guide_played, {
        videoId: videoId,
        title: title,
      });
    }
  };

  useEffect(() => {
    getGuides();
  }, []);

  return (
    <ContainerWrapper id={PageId} enableBackButton={true}>
      <Container
        maxWidth="xs"
        sx={{
          padding: theme.spacing(2, 0, 0, 0),
          ...(isMobile && {
            padding: theme.spacing(1, 1, 0, 1),
          }),
        }}
      >
        <LegacyContentWrapper>
          <TitleWrapper title={i18n("guides.title")}>
            <GameCardGrid columns={1}>
              {!loading
                ? guides?.map((guide: GuideRecord) => (
                    <Button onClick={() => showVideo(guide.video_id, guide.title)} size="large" color="secondary" sx={{ gap: theme.spacing(1) }}>
                      <Icon dsIcon={DSIcon.PLAY} />
                      {i18n(guide.title)}
                    </Button>
                  ))
                : [...Array(6)].map((_, index) => <Skeleton key={index} variant="rounded" height={62} />)}
            </GameCardGrid>
          </TitleWrapper>
        </LegacyContentWrapper>
      </Container>
    </ContainerWrapper>
  );
};

export default Guides;
